import { BaseApi } from './base.api.js';

export class ApplicationRequestInformationApi extends BaseApi {
    constructor(client) {
        super(client, '/application-request-information');
    }
}
